<script>
import { required, maxLength, email } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import { pmsType } from "@/helpers/global.variable";

// Custom Components
import Map from "@/components/NumberMap.vue";
import CustomerService from "@/helpers/APIService/customer.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";

export default {
  data() {
    return {
      pmsTypeOptions: pmsType,
      sdkTypeOpation: [
        { value: "mct01", text: "Mct01" },
        { value: "plustek", text: "Plustek" },
        { value: "apx", text: "APX" },
      ],
      idScanForm: {
        name: "",
        manager_name: "",
        app_code: "",
        email: "",
        phone_number: "",
        manager_phone_number: "",
        record_delete_after: "90",
        currant_version: "",
        licence_expire_at: "",
        city: "",
        state: "",
        country: "",
        zip_code: "",
        address: "",
        sdk_type: "mct01",
        pms_type: "",
        is_face_matching: false,
        is_dnr_check: false,
        is_dnr_check_global: false,
        is_store_photo: false,
        is_active: true,
        is_front_ocr: true,
        is_back_ocr: true,
        write_to_pms_shortcut_key: "CLTR+ALT+p",
        write_to_pms_keys: "",
      },
      isBtnLoading: false,
      submitted: false,
    };
  },
  components: {
    Map,
    DatePicker,
  },
  props: {
    isEdit: Boolean,
    IdScanDetails: Object,
  },
  emits: ["submitted", "cancelSubmit"],
  validations: {
    idScanForm: {
      name: { required },
      app_code: { required, maxLength: maxLength(8) },
      email: { required, email },
      licence_expire_at: { required },
      pms_type: { required },
      sdk_type: { required },
      currant_version: { required },
    },
  },
  mounted() {
    this.setValue();
  },
  methods: {
    // Method is used to set data on edit time
    setValue() {
      if (this.isEdit) {
        Object.keys(this.IdScanDetails).map((key) => {
          if (
            this.IdScanDetails[key] !== null ||
            this.IdScanDetails[key] !== undefined
          ) {
            this.idScanForm[key] = this.IdScanDetails[key];
          }
        });
      }
    },
    onSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        const data = {
          ...this.idScanForm,
          is_face_matching: this.idScanForm.is_face_matching ? 1 : 0,
          is_dnr_check: this.idScanForm.is_dnr_check ? 1 : 0,
          is_dnr_check_global: this.idScanForm.is_dnr_check_global ? 1 : 0,
          is_store_photo: this.idScanForm.is_store_photo ? 1 : 0,
          is_active: this.idScanForm.is_active ? 1 : 0,
        };
        if (this.isEdit) {
          CustomerService.updateCustomer(this.idScanForm.id, this.idScanForm)
            .then((response) => {
              Middleware.notification(
                "Customer update successfully !!",
                "success"
              );
              this.$emit("submitted", response);
              this.isBtnLoading = false;
            })
            .catch((error) => {
              this.isBtnLoading = false;
              errorHandler(error);
            });
        } else {
          CustomerService.addCustomer(this.idScanForm)
            .then((response) => {
              this.isBtnLoading = false;
              Middleware.notification(
                "Customer added successfully !!",
                "success"
              );
              this.$emit("submitted", response);
            })
            .catch((error) => {
              this.isBtnLoading = false;
              errorHandler(error);
            });
        }
      }
    },
    cancelSubmit() {
      this.$emit("cancelSubmit");
    },
    // Method is used to handle search result
    async setPlace(place) {
      let forDetails = [];
      let googleData = place;
      for (
        let index = 0;
        index < googleData.address_components.length;
        index++
      ) {
        const element = googleData.address_components[index];
        forDetails.push(element);
      }

      // To get Location Details like city, state, country etc.
      for (let index = 0; index < forDetails.length; index++) {
        const element = forDetails[index];
        if (element.types[0] == "country") {
          this.idScanForm.country = element.long_name;
        }
        if (element.types[0] == "administrative_area_level_1") {
          this.idScanForm.state = element.short_name;
        }
        if (element.types[0] == "administrative_area_level_2") {
          this.idScanForm.city = element.long_name;
        } else if (element.types[0] == "administrative_area_level_3") {
          this.idScanForm.city = element.long_name;
        }
        if (element.types[0] == "street_number") {
          this.idScanForm.address = element.long_name;
        }
        if (element.types[0] == "route") {
          this.idScanForm.address += `, ${element.long_name}`;
        }
        if (element.types[0] == "locality") {
          this.idScanForm.address = element.long_name;
        }
        if (element.types[0] == "postal_code") {
          this.idScanForm.zip_code = element.long_name;
        }
      }
      this.idScanForm.phone_number = googleData.international_phone_number
        ? googleData.international_phone_number
        : "";
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h4>Add ID Scanner</h4>
        <hr />
      </div>
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="name">
              <span slot="label"> Name<span class="text-danger">*</span> </span>
              <b-form-input
                id="name"
                type="text"
                autocomplete="off"
                v-model="idScanForm.name"
                :class="{
                  'is-invalid': submitted && $v.idScanForm.name.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.idScanForm.name.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.idScanForm.name.required">
                  Company name is required.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="manger_name">
              <span slot="label"> Manger Name</span>
              <b-form-input
                id="manger_name"
                type="text"
                autocomplete="off"
                v-model="idScanForm.manager_name"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="add_code">
              <span slot="label">
                App Code <span class="text-danger">*</span>
              </span>
              <b-form-input
                id="add_code"
                type="text"
                autocomplete="off"
                v-model="idScanForm.app_code"
                :class="{
                  'is-invalid': submitted && $v.idScanForm.app_code.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.idScanForm.app_code.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.idScanForm.app_code.required">
                  App code is required.
                </span>
                <span v-if="!$v.idScanForm.app_code.maxLength">
                  App code not be more then 8 character.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="email">
              <span slot="label"> Email</span>
              <b-form-input
                id="email"
                type="email"
                autocomplete="off"
                v-model="idScanForm.email"
                :class="{
                  'is-invalid': submitted && $v.idScanForm.email.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.idScanForm.email.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.idScanForm.email.email">
                  Enter valid email address.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="phone_no">
              <span slot="label"> Phone Number</span>
              <b-form-input
                id="phone_no"
                type="number"
                autocomplete="off"
                v-model="idScanForm.phone_number"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="manger_phone_no">
              <span slot="label"> Manger Phone Number</span>
              <b-form-input
                id="manger_phone_no"
                type="number"
                autocomplete="off"
                v-model="idScanForm.manager_phone_number"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="licence_exp">
              <span slot="label">
                Licence Expire
                <span class="text-danger">*</span>
              </span>
              <date-picker
                id="upload-date"
                v-model="idScanForm.licence_expire_at"
                format="YYYY-MM-DD"
                value-type="YYYY-MM-DD"
                type="date"
                placeholder="YYYY-MM-DD"
                :class="{
                  'is-invalid':
                    submitted && $v.idScanForm.licence_expire_at.$error,
                }"
              ></date-picker>
              <div
                v-if="submitted && $v.idScanForm.licence_expire_at.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.idScanForm.licence_expire_at.required">
                  Licence Expire is required.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="pms_type">
              <span slot="label">
                PMS Type
                <span class="text-danger">*</span>
              </span>
              <b-form-select
                v-model="idScanForm.pms_type"
                class="form-select"
                id="company-type-input"
                :options="pmsTypeOptions"
                :class="{
                  'is-invalid': submitted && $v.idScanForm.pms_type.$error,
                }"
              >
              </b-form-select>
              <div
                v-if="submitted && $v.idScanForm.pms_type.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.idScanForm.pms_type.required">
                  PMS type is required.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="first_name">
              <span slot="label">
                sdt Type
                <span class="text-danger">*</span>
              </span>
              <b-form-select
                v-model="idScanForm.sdk_type"
                class="form-select"
                id="company-type-input"
                :options="sdkTypeOpation"
                :class="{
                  'is-invalid': submitted && $v.idScanForm.sdk_type.$error,
                }"
              >
              </b-form-select>
              <div
                v-if="submitted && $v.idScanForm.sdk_type.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.idScanForm.sdk_type.required">
                  OCR type is required.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="first_name">
              <span slot="label"> Record Delete</span>
              <b-form-input
                id="first_name"
                type="number"
                autocomplete="off"
                v-model="idScanForm.record_delete_after"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="currant_version">
              <span slot="label">
                Current Version
                <span class="text-danger">*</span>
              </span>
              <b-form-input
                id="currant_version"
                type="number"
                autocomplete="off"
                v-model="idScanForm.currant_version"
                :class="{
                  'is-invalid':
                    submitted && $v.idScanForm.currant_version.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.idScanForm.currant_version.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.idScanForm.currant_version.required">
                  Currant version is required.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-12">
            <h5 class="font-size-15 mb-0">Write To PMS</h5>
            <hr />
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="write_to_pms_shortcut_key">
              <span slot="label"> Shortcut Key</span>
              <b-form-input
                id="write_to_pms_shortcut_key"
                type="text"
                autocomplete="off"
                v-model="idScanForm.write_to_pms_shortcut_key"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="write_to_pms_keys">
              <span slot="label">PMS Input Keys</span>
              <b-form-textarea
                id="write_to_pms_keys"
                type="text"
                autocomplete="off"
                v-model="idScanForm.write_to_pms_keys"
              />
            </b-form-group>
          </div>
          <div class="col-md-12">
            <h5 class="font-size-15 mb-0">Address Information</h5>
            <hr />
          </div>
          <div class="col-md-10">
            <div class="position-relative mb-3">
              <Map class="w-100" @update:place="setPlace"></Map>
            </div>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="first_name">
              <span slot="label"> Address</span>
              <b-form-input
                id="first_name"
                type="text"
                autocomplete="off"
                v-model="idScanForm.address"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="first_name">
              <span slot="label"> City</span>
              <b-form-input
                id="first_name"
                type="text"
                autocomplete="off"
                v-model="idScanForm.city"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="first_name">
              <span slot="label"> State</span>
              <b-form-input
                id="first_name"
                type="text"
                autocomplete="off"
                v-model="idScanForm.state"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="first_name">
              <span slot="label"> Country</span>
              <b-form-input
                id="first_name"
                type="text"
                autocomplete="off"
                v-model="idScanForm.country"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="first_name">
              <span slot="label"> Zip Code</span>
              <b-form-input
                id="first_name"
                type="text"
                autocomplete="off"
                v-model="idScanForm.zip_code"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-12">
            <h5 class="font-size-15 mb-0">Other Information</h5>
            <hr />
          </div>
          <div class="col-lg-2 col-md-3 col-sm-4 col-6">
            <div class="mb-3">
              <label for="push_notification">Face Matching</label>
              <div class="form-check form-switch form-switch-md">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="is_face_matching"
                  v-model="idScanForm.is_face_matching"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-3 col-sm-4 col-6">
            <div class="mb-3">
              <label for="status">Dnr Check</label>
              <div class="form-check form-switch form-switch-md">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="is_dnr_check"
                  v-model="idScanForm.is_dnr_check"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-3 col-sm-4 col-6">
            <div class="mb-3">
              <label for="push_notification">Dnr Check Global</label>
              <div class="form-check form-switch form-switch-md">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="is_dnr_check_global"
                  v-model="idScanForm.is_dnr_check_global"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-3 col-sm-4 col-6">
            <div class="mb-3">
              <label for="status">Store Photo</label>
              <div class="form-check form-switch form-switch-md">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="is_store_photo"
                  v-model="idScanForm.is_store_photo"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-3 col-sm-4 col-6">
            <div class="mb-3">
              <label for="push_notification">Front OCR</label>
              <div class="form-check form-switch form-switch-md">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="is_front_ocr"
                  v-model="idScanForm.is_front_ocr"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-3 col-sm-4 col-6">
            <div class="mb-3">
              <label for="push_notification">Back OCR</label>
              <div class="form-check form-switch form-switch-md">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="is_back_ocr"
                  v-model="idScanForm.is_back_ocr"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-3 col-sm-4 col-6">
            <div class="mb-3">
              <label for="push_notification">Active</label>
              <div class="form-check form-switch form-switch-md">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="is_active"
                  v-model="idScanForm.is_active"
                />
              </div>
            </div>
          </div>

          <hr />
          <div class="col-md-12">
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              type="reset"
              @click="cancelSubmit"
              >Cancel</b-button
            >
            <b-button
              class="float-end"
              variant="outline-primary"
              type="submit"
              @click.prevent="onSubmit"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="isBtnLoading"
              ></i>
              {{ this.isEdit ? "Update" : "Save" }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
